// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3494":"68cba389f9ba11e4","8990":"7e767d279854ffcf"}[chunkId] + ".css";
};